import { render, staticRenderFns } from "./SellingDrugs.vue?vue&type=template&id=abb3af82&scoped=true"
import script from "./SellingDrugs.vue?vue&type=script&lang=js"
export * from "./SellingDrugs.vue?vue&type=script&lang=js"
import style0 from "./SellingDrugs.vue?vue&type=style&index=0&id=abb3af82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb3af82",
  null
  
)

export default component.exports